<template>
    <div class="form-content pl-2 pr-2">
        <div class="form-group">
            <div>
                <label class="col-md-2 control-label">Room Types</label>
                <div class="col-md-10">
                    <div class="checkbox">
                        <input type="checkbox" :checked="payload.selectedHotelRooms.length === payload.hotelRooms.length" name="hotelRooms" value="true" @change="toggleAllHotelRooms()" :disabled="payload.selectClosed"> All Room Types
                    </div>
                    <div v-for="hotelRoom in payload.hotelRooms" class="checkbox">
                        <input type="checkbox" :checked="payload.selectedHotelRooms.includes(hotelRoom.hotelRoomKey)" @change="toggleHotelRoom(hotelRoom.hotelRoomKey)" :disabled="payload.selectClosed"/> {{ hotelRoom.name }}
                    </div>
                </div>
            </div>
        </div>
        
        <div class="form-group">
            <div>
                <label class="col-md-2 control-label">Availability</label>
                <div class="col-md-10">
                    <div class="checkbox">
                        <input type="checkbox" name="availability" @change="toggleShowAvailability()" :disabled="payload.selectClosed"> Room Availability
                    </div>
                    
                    <div class="checkbox">
                        <input type="checkbox" name="closed" value="true" @change="toggleClosed()"> Whole Property Closed
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div>
                <label class="col-md-2 control-label">Rates</label>
                <div class="col-md-10">
                    <div v-for="(rate, index) in payload.rateTypes" :key="index" class="checkbox">
                        <input type="checkbox" @change="toggleRateType(rate.rateTypeKey)" :disabled="payload.selectClosed"/> {{ rate.name }}
                    </div>

                    <div v-if="payload.additionalRates.length">
                        <hr class="mb-1">
                        <div v-for="(rate) in payload.additionalRates" class="checkbox">
                            <input type="checkbox" @change="toggleAdditionalRate(rate.field)" :disabled="payload.selectClosed"/> {{ rate.text }}
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        
        <div class="form-group">
            <div>
                <label class="col-md-2 control-label">Restrictions</label>
                <div class="col-md-10">
                    <div v-for="(restriction) in payload.restrictions" class="checkbox">
                        <input type="checkbox" @change="toggleRestriction(restriction.value)" :disabled="payload.selectClosed"/> {{ restriction.text }}
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
/**
 * A Vue component for the user to select which fields they would like to update using the batch loader
 *
 */

export default {
    name: 'hotel-batch-loader-weekday-selector',
    props: ['payload'],
    data () {
        return { 
        }
    },

    methods: {
        toggleShowAvailability() {
            this.$emit('toggle-show-availability');
        },

        toggleClosed() {
            this.$emit('toggle-closed');
        },

        toggleAllHotelRooms() {
            this.$emit('toggle-all-hotel-rooms');
        },

        toggleHotelRoom(hotelRoomKey) {
            this.$emit('toggle-hotel-room', hotelRoomKey);
        },

        toggleAdditionalRate(columnName) {
            this.$emit('toggle-additional-rate', columnName);
        },

        toggleRateType(rateTypeKey) {
            this.$emit('toggle-rate-type', rateTypeKey);
        },

        toggleRestriction(columnName){
            this.$emit('toggle-restriction', columnName);
        },
    },

    /**
     * Once mounted this component needs to load all available models
     */
    mounted() {
    },

    computed: {

    },

    watch: 
        {
    }
}
</script>

<style>
    
</style>
